import { z } from 'zod';
export const insuranceClaimsImportCapability = 'insurance-claims.import-reconciliation.v1';
export const insuranceClaimsImportManifestVersion = 'insurance-claims-source-manifest.v1';
export const insuranceClaimsImportMappingVersion = 'insurance-claims-normalized-v1';
export const insuranceClaimsImportRunStatusSchema = z.enum([
    'prepared', 'applying', 'reconciled', 'failed', 'rolled-back',
]);
export const insuranceClaimsImportCountsByEntitySchema = z.strictObject({
    claim: z.number().int().nonnegative().safe(),
    supplement: z.number().int().nonnegative().safe(),
    scope: z.number().int().nonnegative().safe(),
    'claim-coach': z.number().int().nonnegative().safe(),
    'aob-notice': z.number().int().nonnegative().safe(),
    'adjuster-sla-override': z.number().int().nonnegative().safe(),
    'carrier-estimate-review': z.number().int().nonnegative().safe(),
    'compliance-review': z.number().int().nonnegative().safe(),
    'payment-administration': z.number().int().nonnegative().safe(),
});
export const insuranceClaimsImportDomainTotalsSchema = z.strictObject({
    claimVersionCount: z.number().int().nonnegative().safe(),
    supplementVersionCount: z.number().int().nonnegative().safe(),
    supplementLineCount: z.number().int().nonnegative().safe(),
    supplementRequestedCents: z.number().int().nonnegative().safe(),
    supplementApprovedCents: z.number().int().nonnegative().safe(),
    scopeVersionCount: z.number().int().nonnegative().safe(),
    scopeAllocatedCents: z.number().int().nonnegative().safe(),
    claimCoachVersionCount: z.number().int().nonnegative().safe(),
    claimCoachStepCount: z.number().int().nonnegative().safe(),
    aobNoticeVersionCount: z.number().int().nonnegative().safe(),
    adjusterSlaOverrideVersionCount: z.number().int().nonnegative().safe(),
    carrierReviewVersionCount: z.number().int().nonnegative().safe(),
    carrierReviewLineCount: z.number().int().nonnegative().safe(),
    carrierReviewRcvCents: z.number().int().nonnegative().safe(),
    complianceReviewVersionCount: z.number().int().nonnegative().safe(),
    paymentAdministrationVersionCount: z.number().int().nonnegative().safe(),
    paymentMilestoneCount: z.number().int().nonnegative().safe(),
    paymentMilestoneAmountCents: z.number().int().nonnegative().safe(),
});
export const insuranceClaimsImportRunSummarySchema = z.strictObject({
    contractVersion: z.literal(insuranceClaimsImportCapability),
    tenantId: z.string().uuid(),
    id: z.string().uuid(),
    manifestVersion: z.literal(insuranceClaimsImportManifestVersion),
    mappingVersion: z.literal(insuranceClaimsImportMappingVersion),
    sourceSystem: z.literal('crest-crm'),
    sourceRepository: z.literal('jakeflora-cell/crest-crm'),
    sourceCommitSha: z.string().regex(/^[a-f0-9]{40}$/),
    sourceSchemaSha256: z.string().regex(/^[a-f0-9]{64}$/),
    sourceManifestSha256: z.string().regex(/^[a-f0-9]{64}$/),
    tenantExternalKey: z.string().trim().min(1).max(240),
    runKind: z.enum(['base', 'final-delta']),
    sourceEpoch: z.string().trim().min(1).max(240),
    parentSourceSha256: z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    sourceSha256: z.string().regex(/^[a-f0-9]{64}$/),
    planSha256: z.string().regex(/^[a-f0-9]{64}$/),
    status: insuranceClaimsImportRunStatusSchema,
    sourceRows: z.number().int().nonnegative(),
    plannedRows: z.number().int().nonnegative(),
    rejectedRows: z.number().int().nonnegative(),
    appliedRows: z.number().int().nonnegative().nullable(),
    skippedRows: z.number().int().nonnegative().nullable(),
    tombstonedRows: z.number().int().nonnegative().nullable(),
    targetSha256: z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    countsByEntity: insuranceClaimsImportCountsByEntitySchema.nullable(),
    domainTotals: insuranceClaimsImportDomainTotalsSchema.nullable(),
    failureReasonCode: z.string().trim().min(3).max(160).nullable(),
    rollbackReason: z.string().trim().min(10).max(1_000).nullable(),
    startedByMembershipId: z.string().uuid(),
    startedAt: z.string().datetime({ offset: true }),
    completedAt: z.string().datetime({ offset: true }).nullable(),
    rolledBackAt: z.string().datetime({ offset: true }).nullable(),
});
//# sourceMappingURL=insurance-claims-import.contract.js.map